import { NgModule } from '@angular/core';
import { CoreModule } from 'src/app/core/core.module.js';
import { ManagageUserSessionsComponent } from './manage-user-sessions.component.js';
import { FormModule } from 'lib/ui/form/form.module.js';
import { EditSessionComponent } from './edit-session.component.js';
import { SelectionCardsModule } from '../../../../lib/ui/selection-cards/selection-cards.module.js';
import { SessionComplianceComponent } from './session-compliance.component.js';

@NgModule({
	declarations: [ManagageUserSessionsComponent, EditSessionComponent, SessionComplianceComponent],
	exports: [ManagageUserSessionsComponent, EditSessionComponent, SessionComplianceComponent],
	imports: [CoreModule, FormModule, SelectionCardsModule]
})
export class SessionsModule {}
